module.exports = {"TXTINS_Next":{"id":"TXTINS_Next","defaultMessage":"Next","track":"Next"}}